/*
 * HACK: "Sasad Resort Sungate I." and "Sasad Resort Sungate II." are two
 * separate Salesforce projects tied to a single residentials-cpt post /
 * single map pin. The pin's own data only ever exposes one of the two SF
 * project names (see flat-search-results.php + acf_load_sf_project_choices),
 * so the normal $.filterMarkers() project-name matching only succeeds for
 * whichever one it happens to expose.
 *
 * This file does not modify 03_map-search.js or 04_lakaskereso.js at all. It
 * wraps the existing $.filterMarkers (defined in 03_map-search.js) so that,
 * whenever any currently selected "lakopark" filter is a Sasad Resort
 * Sungate variant, the residential/project arrays passed into the *original,
 * untouched* $.filterMarkers are augmented with whatever that pin's marker
 * object already carries (marker.residential / marker.project, set once at
 * marker creation in search_add_marker()). The original function then does
 * all the normal work (visibility, clustering, map centering) exactly as it
 * already does for any legitimate match - we are not duplicating or
 * reimplementing any of that.
 *
 * Loads last (glob-concatenated after 03_ and 04_) so $.filterMarkers and
 * $.lakaskereso already exist when this file runs.
 */
(function ($) {
  var originalFilterMarkers = $.filterMarkers;

  if (typeof originalFilterMarkers !== "function") {
    console.warn("[SUNGATE HACK] $.filterMarkers not found, hack not installed");
    return;
  }

  console.log("[SUNGATE HACK] installed on top of $.filterMarkers");

  $.filterMarkers = function (residential, project) {
    var augmentedResidential = (residential || []).slice();
    var augmentedProject = (project || []).slice();

    var lakoparkFilter =
      ($.lakaskereso && $.lakaskereso.filters && $.lakaskereso.filters.lakopark) || [];

    var sungateSelected = lakoparkFilter.some(
      (v) => v && v.toString().indexOf("Sasad Resort Sungate") === 0,
    );

    console.log("[SUNGATE HACK] filterMarkers called", {
      lakoparkFilter: lakoparkFilter,
      sungateSelected: sungateSelected,
      incomingResidential: residential,
      incomingProject: project,
    });

    if (sungateSelected && $.searchMap != null && $.searchMap.markers) {
      $.searchMap.markers.forEach(function (marker) {
        if (
          !Array.isArray(marker.project) ||
          !marker.project.some(
            (p) => p && p.toString().indexOf("Sasad Resort Sungate") === 0,
          )
        ) {
          return;
        }

        var residentialKey = marker.residential.toString();
        if (augmentedResidential.indexOf(residentialKey) === -1) {
          augmentedResidential.push(residentialKey);
        }

        marker.project.forEach(function (p) {
          if (augmentedProject.indexOf(p) === -1) {
            augmentedProject.push(p);
          }
        });

        console.log("[SUNGATE HACK] augmented arrays with Sungate marker data", {
          markerResidential: marker.residential,
          markerProject: marker.project,
          augmentedResidential: augmentedResidential,
          augmentedProject: augmentedProject,
        });
      });
    }

    return originalFilterMarkers(augmentedResidential, augmentedProject);
  };
})(jQuery);
